import React, { useEffect, useState } from 'react'
import styles from './style'
import propTypes from './prop'

import { withStyles, Alert, CircularProgress } from '@material-ui/core'

import {
  useCardSettings,
  createSetting,
  patchSetting,
} from 'src/hooks/useCardSettings'
import { QuestionFieldNames } from 'src/model/card'

import { guid } from 'src/utils/guid'
import {
  componentBoxShowAction,
  componentBoxHideAction,
} from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'

import translator from 'src/translate'
import ModalContent from './popup'
import { CoreButton } from 'src/components/core'
const has = numeric => {
  if (numeric == 0) return true

  return numeric ? true : false
}

const ResultCard = props => {
  const { classes, entity, dispatch } = props
  const [componentBoxContent, setComponentBoxContent] = useState(false)

  const cardId = entity && entity[QuestionFieldNames.ID]

  const settings = useCardSettings(QuestionFieldNames.RESULT_CONDITIONS)
  const resultConditions = settings ? JSON.parse(settings.value) : undefined

  useEffect(() => {
    if (!resultConditions) {
      createSetting(
        dispatch,
        cardId,
        QuestionFieldNames.RESULT_CONDITIONS,
        JSON.stringify([]),
      )
    }
  }, [resultConditions])

  const saveCondition = data => {
    if (!settings) return
    const settingId = settings.id

    patchSetting(
      dispatch,
      cardId,
      settingId,
      QuestionFieldNames.RESULT_CONDITIONS,
      JSON.stringify(data),
    )
    dispatch(componentBoxHideAction(componentBoxContent))
    setComponentBoxContent(false)
  }

  const handleOpenPopup = (id, header) => {
    const component = new ComponentBoxContent(
      (
        <ModalContent
          {...props}
          conditions={resultConditions}
          conditionId={id}
          key={guid.uid}
          actionType={has(id) ? 'edit' : 'add'}
          saveCondition={saveCondition}
        />
      ),
      {
        hideCloseButton: false,
        header: has(id)
          ? header
          : translator._('taskItem.resultCard.conditions'),
        callback: e => {},
      },
    )
    setComponentBoxContent(component)
    dispatch(componentBoxShowAction(component))
  }

  return (
    <>
      {resultConditions && typeof resultConditions != 'undefined' ? (
        <div className={classes.wrapper}>
          {resultConditions && resultConditions.length > 0 ? (
            <div className={classes.centerWrapper}>
              {resultConditions.map((value, index) => {
                const header = `${value.type} ${value.condition} ${value.value}`
                return (
                  <CoreButton
                    variant="outlined"
                    onClick={() => handleOpenPopup(index, header)}
                  >
                    {header}
                  </CoreButton>
                )
              })}
            </div>
          ) : (
            <Alert severity="warning">
              You must add at least 1 condition for this card to work.
            </Alert>
          )}
          <CoreButton variant="contained" onClick={() => handleOpenPopup()}>
            Add condition
          </CoreButton>
        </div>
      ) : (
        <CircularProgress />
      )}
    </>
  )
}

ResultCard.propTypes = propTypes

export default withStyles(styles)(ResultCard)
